import { ModelDocuments } from 'shared';
import page from './page.graphql';

export const LedgerDocuments: Omit<ModelDocuments, 'entity'> = {
  list: {
    page,
  },
};
